import {
  useEffect,
  useState,
} from "react";

import {
  FaClock,
  FaMapMarkerAlt,
  FaRoute,
  FaTruckMoving,
} from "react-icons/fa";

import "./ViaggioFiorinoCard.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://interventi.synology.me:5050";

const formatDateTime = (value) => {
  if (!value) return "—";

  const date = new Date(value);

  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString("it-IT");
};

const formatDuration = (
  seconds,
  startTime,
  currentTime
) => {
  let totalSeconds = Number(seconds);

  if (
    !Number.isFinite(totalSeconds) &&
    startTime
  ) {
    const start = new Date(startTime).getTime();

    if (Number.isFinite(start)) {
      totalSeconds = Math.max(
        0,
        Math.floor(
          (currentTime - start) / 1000
        )
      );
    }
  }

  if (!Number.isFinite(totalSeconds)) {
    return "—";
  }

  const hours = Math.floor(
    totalSeconds / 3600
  );

  const minutes = Math.floor(
    (totalSeconds % 3600) / 60
  );

  const remainingSeconds =
    Math.floor(totalSeconds % 60);

  if (hours > 0) {
    return `${hours} h ${minutes} min`;
  }

  if (minutes > 0) {
    return `${minutes} min ${remainingSeconds} sec`;
  }

  return `${remainingSeconds} sec`;
};

const formatDistance = (meters) => {
  const value = Number(meters);

  if (!Number.isFinite(value)) {
    return "—";
  }

  if (value < 1000) {
    return `${Math.round(value)} m`;
  }

  return `${(value / 1000).toFixed(2)} km`;
};

const getStatusLabel = (status) => {
  const labels = {
    assegnato: "Assegnato",
    in_viaggio: "In viaggio",
    arrivato: "Arrivato",
    completato: "Completato",
    annullato: "Annullato",
  };

  return labels[status] || status || "—";
};

const ViaggioFiorinoCard = ({
  refreshKey = 0,
}) => {
  const [trip, setTrip] = useState(null);
  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const [currentTime, setCurrentTime] =
    useState(Date.now());

  const [
    startingIntervention,
    setStartingIntervention,
  ] = useState(false);

const [
closingTrip,
setClosingTrip,
] = useState(false);

  const [
    actionMessage,
    setActionMessage,
  ] = useState("");

  const [
    kmPercorsiInput,
    setKmPercorsiInput,
  ] = useState("");

  const [
    minutiPercorrenzaInput,
    setMinutiPercorrenzaInput,
  ] = useState("");

  const [
    savingTravelData,
    setSavingTravelData,
  ] = useState(false);

  const [
    travelMessage,
    setTravelMessage,
  ] = useState("");

  const loadTrip = async () => {
    try {
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE_URL}/api/flotta/viaggio-attivo`,
        {
          headers: token
            ? {
                Authorization:
                  `Bearer ${token}`,
              }
            : {},
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}`
        );
      }

      const data = await response.json();

      if (data.trip) {
        setActionMessage("");
      }

      setTrip(data.trip || null);
      setError("");
    } catch (requestError) {
      console.error(
        "Errore caricamento viaggio Fiorino:",
        requestError
      );

      setError(
        "Stato viaggio non disponibile"
      );
    } finally {
      setLoading(false);
    }
  };

  const saveTravelData = async () => {
    if (
      !trip?.intervento_id ||
      trip.stato !== "arrivato"
    ) {
      return;
    }

    const kmPercorsi = Number.parseInt(
      kmPercorsiInput,
      10
    );

    const minutiPercorrenza =
      Number.parseInt(
        minutiPercorrenzaInput,
        10
      );

    if (
      !Number.isInteger(kmPercorsi) ||
      kmPercorsi < 0 ||
      kmPercorsi > 2000
    ) {
      setError(
        "Inserisci chilometri validi"
      );
      return;
    }

    if (
      !Number.isInteger(
        minutiPercorrenza
      ) ||
      minutiPercorrenza < 0 ||
      minutiPercorrenza > 1440
    ) {
      setError(
        "Inserisci minuti validi"
      );
      return;
    }

    setSavingTravelData(true);
    setError("");
    setTravelMessage("");

    try {
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE_URL}/api/flotta/viaggio-attivo/registra-percorrenza`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type":
              "application/json",
            ...(token
              ? {
                  Authorization:
                    `Bearer ${token}`,
                }
              : {}),
          },
          body: JSON.stringify({
            kmPercorsi,
            minutiPercorrenza,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.error ||
            `HTTP ${response.status}`
        );
      }

      setTravelMessage(
        `${kmPercorsi} km e ` +
        `${minutiPercorrenza} minuti ` +
        "registrati nell'intervento."
      );
    } catch (requestError) {
      console.error(
        "Errore registrazione percorrenza:",
        requestError
      );

      setError(
        requestError.message ||
          "Registrazione non riuscita"
      );
    } finally {
      setSavingTravelData(false);
    }
  };

  // === CHIUSURA VIAGGIO PLURIGIORNALIERO 2026 ===
const closeTripOnly = async () => {
if (
!trip?.intervento_id ||
trip.stato !== "arrivato"
) {
return;
}

const confirmed = window.confirm(
"Chiudere il viaggio di oggi?\n\n" +
"L'intervento resterà aperto e potrai continuare " +
"a registrare normalmente le giornate di lavoro."
);

if (!confirmed) {
return;
}

setClosingTrip(true);
setError("");
setActionMessage("");

try {
const token =
localStorage.getItem("token");

const response = await fetch(
`${API_BASE_URL}/api/flotta/viaggio-attivo/chiudi-viaggio`,
{
method: "POST",
headers: {
Accept: "application/json",
...(token
? {
Authorization:
`Bearer ${token}`,
}
: {}),
},
}
);

const data = await response.json();

if (!response.ok || !data.success) {
throw new Error(
data.error ||
`HTTP ${response.status}`
);
}

setTrip(null);

setActionMessage(
"Viaggio di oggi chiuso. L'intervento resta aperto."
);

} catch (requestError) {
console.error(
"Errore chiusura viaggio:",
requestError
);

setError(
requestError.message ||
"Impossibile chiudere il viaggio"
);
} finally {
setClosingTrip(false);
}
};

const startIntervention = async () => {
    if (
      !trip?.intervento_id ||
      trip.stato !== "arrivato"
    ) {
      return;
    }

    const confirmed = window.confirm(
      `Avviare l'intervento #${trip.intervento_id}?`
    );

    if (!confirmed) {
      return;
    }

    setStartingIntervention(true);
    setError("");

    try {
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE_URL}/api/flotta/viaggio-attivo/avvia-intervento`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            ...(token
              ? {
                  Authorization:
                    `Bearer ${token}`,
                }
              : {}),
          },
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.error ||
            `HTTP ${response.status}`
        );
      }

      setTrip(
        data.trip || {
          ...trip,
          stato: "completato",
        }
      );

      setActionMessage(
        `Intervento #${trip.intervento_id} avviato correttamente.`
      );
    } catch (requestError) {
      console.error(
        "Errore avvio intervento:",
        requestError
      );

      setError(
        requestError.message ||
          "Impossibile avviare l'intervento"
      );
    } finally {
      setStartingIntervention(false);
    }
  };

  useEffect(() => {
    loadTrip();

    const refreshInterval = setInterval(
      loadTrip,
      10000
    );

    const clockInterval = setInterval(
      () => setCurrentTime(Date.now()),
      1000
    );

    return () => {
      clearInterval(refreshInterval);
      clearInterval(clockInterval);
    };
  }, []);

  // Precompilazione percorrenza rilevata
  useEffect(() => {
    if (
      !trip ||
      trip.stato !== "arrivato"
    ) {
      return;
    }

    const distanceMeters =
      Number(trip.distanza_gps_m);

    const durationSeconds =
      Number(trip.durata_viaggio_sec);

    setKmPercorsiInput((current) => {
      if (current !== "") {
        return current;
      }

      if (
        !Number.isFinite(distanceMeters)
      ) {
        return "0";
      }

      return String(
        Math.max(
          0,
          Math.round(distanceMeters / 1000)
        )
      );
    });

    setMinutiPercorrenzaInput(
      (current) => {
        if (current !== "") {
          return current;
        }

        if (
          !Number.isFinite(
            durationSeconds
          )
        ) {
          return "0";
        }

        return String(
          Math.max(
            0,
            Math.ceil(
              durationSeconds / 60
            )
          )
        );
      }
    );
  }, [
    trip?.id,
    trip?.stato,
    trip?.distanza_gps_m,
    trip?.durata_viaggio_sec,
  ]);

  // Refresh manuale richiesto da Flotta
  useEffect(() => {
    if (refreshKey > 0) {
      loadTrip();
    }
  }, [refreshKey]);

  if (loading) {
    return (
      <section className="flotta-card flotta-trip-card">
        Caricamento viaggio Fiorino...
      </section>
    );
  }

  if (!trip) {
    return (
      <section className="flotta-card flotta-trip-card">
        <div className="flotta-trip-title">
          <h3>
            <FaTruckMoving />
            Viaggio Fiorino
          </h3>

          <span className="flotta-trip-status idle">
            Nessun viaggio
          </span>
        </div>

        <p className="flotta-trip-empty">
          Nessun intervento attualmente
          assegnato al Fiorino.
        </p>

        {actionMessage && (
          <p className="flotta-trip-success">
            {actionMessage}
          </p>
        )}

        {error && (
          <p className="flotta-trip-error">
            {error}
          </p>
        )}
      </section>
    );
  }

  const status = trip.stato;

  let statusDescription =
    "Viaggio predisposto";

  if (status === "assegnato") {
    statusDescription =
      trip.last_telemetry_time
        ? `Conferme partenza: ${
            trip.departure_hits || 0
          }`
        : "In attesa di GPS valido";
  }

  if (status === "in_viaggio") {
    statusDescription =
      `Conferme arrivo nel geofence: ${
        trip.arrival_hits || 0
      }`;
  }

  if (status === "arrivato") {
    statusDescription =
      "Arrivo rilevato nel geofence";
  }


  const timelineSteps = [
    "Assegnato",
    "In viaggio",
    "Arrivato",
    "Intervento avviato",
  ];

  const timelineStatusIndex = {
    assegnato: 0,
    in_viaggio: 1,
    arrivato: 2,
    completato: 3,
  };

  const currentTimelineIndex =
    timelineStatusIndex[status] ?? -1;
  return (
    <section className="flotta-card flotta-trip-card">
      <div className="flotta-trip-title">
        <div>
          <h3>
            <FaTruckMoving />
            Viaggio Fiorino
          </h3>

          <p>{statusDescription}</p>
        </div>

        <span
          className={
            `flotta-trip-status ${status}`
          }
        >
          {getStatusLabel(status)}
        </span>
      </div>

      <div className="flotta-trip-timeline">
        {timelineSteps.map((step, index) => {
          const stepState =
            currentTimelineIndex > index
              ? "done"
              : currentTimelineIndex === index
              ? "current"
              : "pending";

          return (
            <div
              key={step}
              className={`flotta-trip-step ${stepState}`}
            >
              <span className="flotta-trip-step-dot">
                {index + 1}
              </span>
              <span className="flotta-trip-step-label">
                {step}
              </span>
            </div>
          );
        })}
      </div>

      <div className="flotta-trip-grid">
        <div>
          <strong>Intervento</strong>
          <span>
            {trip.numero_foglio_intervento ||
              `#${trip.intervento_id}`}
          </span>
        </div>

        <div>
          <strong>
            <FaMapMarkerAlt />
            Destinazione
          </strong>

          <span>
            {trip.indirizzo_destinazione ||
              "—"}
          </span>
        </div>

        <div>
          <strong>Assegnato</strong>
          <span>
            {formatDateTime(
              trip.assegnato_il
            )}
          </span>
        </div>

        <div>
          <strong>Partenza</strong>
          <span>
            {formatDateTime(
              trip.partenza_il
            )}
          </span>
        </div>

        <div>
          <strong>Arrivo</strong>
          <span>
            {formatDateTime(
              trip.arrivo_il
            )}
          </span>
        </div>

        <div>
          <strong>
            <FaClock />
            Durata viaggio
          </strong>

          <span>
            {formatDuration(
              trip.durata_viaggio_sec,
              trip.partenza_il,
              currentTime
            )}
          </span>
        </div>

        <div>
          <strong>
            <FaRoute />
            Distanza GPS
          </strong>

          <span>
            {formatDistance(
              trip.distanza_gps_m
            )}
          </span>
        </div>

        <div>
          <strong>Geofence</strong>
          <span>
            {trip.geofence_raggio_m ||
              150} m
          </span>
        </div>

        <div>
          <strong>Ultimo campione</strong>
          <span>
            {formatDateTime(
              trip.last_telemetry_time
            )}
          </span>
        </div>

        <div>
          <strong>Contatore FMC920</strong>
          <span>
            {trip.odometer_end ??
              trip.odometer_start ??
              "—"}
          </span>
        </div>
      </div>

      {status === "arrivato" && (
        <div className="flotta-trip-travel-form">
          <div className="flotta-trip-travel-heading">
            <strong>
              Registra percorrenza
            </strong>

            <span>
              Controlla i valori rilevati
              prima del salvataggio.
            </span>
          </div>

          <div className="flotta-trip-travel-fields">
            <label>
              <span>Km percorsi</span>

              <input
                type="number"
                min="0"
                max="2000"
                step="1"
                inputMode="numeric"
                value={kmPercorsiInput}
                onChange={(event) => {
                  setKmPercorsiInput(
                    event.target.value
                  );
                  setTravelMessage("");
                }}
              />
            </label>

            <label>
              <span>
                Tempo percorrenza
              </span>

              <div className="flotta-trip-minutes-input">
                <input
                  type="number"
                  min="0"
                  max="1440"
                  step="1"
                  inputMode="numeric"
                  value={
                    minutiPercorrenzaInput
                  }
                  onChange={(event) => {
                    setMinutiPercorrenzaInput(
                      event.target.value
                    );
                    setTravelMessage("");
                  }}
                />

                <span>minuti</span>
              </div>
            </label>

            <button
              type="button"
              onClick={saveTravelData}
              disabled={savingTravelData}
            >
              {savingTravelData
                ? "Registrazione..."
                : "Registra km e tempo"}
            </button>
          </div>

          {travelMessage && (
            <p className="flotta-trip-success">
              {travelMessage}
            </p>
          )}
        </div>
      )}

      {status === "arrivato" && (
        <div className="flotta-trip-action">
          <button
        type="button"
        className="flotta-close-trip-btn"
        onClick={closeTripOnly}
        disabled={
          closingTrip ||
          startingIntervention
        }
      >
        {closingTrip
          ? "Chiusura viaggio..."
          : "Chiudi viaggio di oggi"}
      </button>

      <button
        type="button"
        onClick={startIntervention}
        disabled={
          startingIntervention ||
          closingTrip
        }
      >
            {startingIntervention
              ? "Avvio in corso..."
              : `Avvia intervento ${
                  trip.numero_foglio_intervento ||
                  `#${trip.intervento_id}`
                }`}
          </button>

          <span>
            L'ora di inizio verrà registrata
            automaticamente.
          </span>
        </div>
      )}

      {actionMessage && (
        <p className="flotta-trip-success">
          {actionMessage}
        </p>
      )}

      {error && (
        <p className="flotta-trip-error">
          {error}. Sono mostrati gli ultimi
          dati disponibili.
        </p>
      )}
    </section>
  );
};

export default ViaggioFiorinoCard;
